import { DefineGetters } from "vuex-type-helper";
import { AtlasfileGetters, AtlasfileState } from "./types";

export const getters: DefineGetters<AtlasfileGetters, AtlasfileState> = {
  getTotalRecords: ({ links, atlasfiles }: AtlasfileState) =>
    links && links.totalRecords ? links.totalRecords : atlasfiles.length,
  getAtlasfileById: (state: AtlasfileState) => (fileId: string) =>
    state.atlasfiles.find((file: any) => file._id === fileId)
};
